export default __webpack_public_path__ + "static/media/marker-good.442519f0.svg";